var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st1{fill:#ACACAC;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.9,900.1c-15.3,0-29.1-9.1-35.2-23.1c-6.2-14.2-3.3-30.6,7.4-41.8c1.6-1.7,59.4-64.9,81.9-136.1     c-27.5-29.7-49.4-62.5-65-97.5c-18.3-41-27.5-84.2-27.5-128.3c0-51.1,12.3-100.6,36.5-147.1c23.2-44.5,56.2-84.4,98.3-118.5     c85.4-69.4,198.6-107.6,318.8-107.6c120.2,0,233.4,38.2,318.8,107.6c42,34.1,75.1,74,98.2,118.5c24.2,46.5,36.5,96,36.5,147.1     s-12.3,100.6-36.5,147.1C894,665,860.9,704.9,818.9,739c-85.4,69.4-198.6,107.6-318.8,107.6c-60.3,0-119.2-9.9-175.4-29.3     c-26.9,20-55.7,36.9-85.9,50.1C189,889.1,137.2,900.1,84.9,900.1z M93.3,869.8L93.3,869.8c0.2-0.1,0.3-0.3,0.4-0.5     C93.5,869.6,93.4,869.7,93.3,869.8z M500.1,150.2c-222.5,0-403.6,145-403.6,323.2c0,37.1,7.8,73.4,23.2,108     c15,33.7,36.8,65,64.9,93.2l10,10l-3.4,13.7c-15.8,63.7-56.4,121.2-80.2,150.9c36.5-3,72.7-12.2,107.8-27.6     c30-13.1,59.7-31.1,85.9-52l11.1-8.8l13.3,5c54.5,20.5,112,30.9,171,30.9c222.5,0,403.6-145,403.6-323.2S722.6,150.2,500.1,150.2     z M57.3,835.2C57.2,835.2,57.2,835.2,57.3,835.2L57.3,835.2z M57.5,834.9c0,0-0.1,0.1-0.1,0.1L57.5,834.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378,472c0,46.3-37.5,83.7-83.7,83.7s-83.7-37.4-83.7-83.7s37.5-83.7,83.7-83.7S378,425.7,378,472z     M499,555.7c-46.3,0-83.7-37.4-83.7-83.7s37.4-83.7,83.7-83.7s83.7,37.4,83.7,83.7S545.3,555.7,499,555.7z M787.4,472    c0,46.3-37.4,83.7-83.7,83.7c-46.3,0-83.7-37.4-83.7-83.7s37.4-83.7,83.7-83.7C750,388.3,787.4,425.7,787.4,472z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.b44187093a56df55de504ed745b060bd.svg";
export { ForwardRef as ReactComponent };